export async function processBack(props, state) {
	console.log('Back Check', props, state);
}

export async function processBackButton(path, props) {
	// const referrer = document.referrer;
	// showTopBar();
	// console.log(`back processing`, {
	// 	action,
	// 	location,
	// 	hash: window.location.hash,
	// 	history,
	// 	referrer,
	// });

	// if (action === 'POP') {
	// 	// history.go(-2);
	// }

	// if (path === '/restoreState') {
	// 	console.log('hand back state:' + localStorage.getItem('state'));
	// 	props.history.push({
	// 		pathname: '/openScheduling',
	// 		restore: true,
	// 		state: JSON.parse(localStorage.getItem('state')),
	// 	});
	// 	return false;
	// }
	const key = `screen-${path}`;
	const referrer = document.referrer;
	console.log('back button check', key, referrer, document.location, props);
	if (sessionStorage.getItem(key)) {
		// document.write(
		// 	`Coming back.  Redirect to ` +
		// 		sessionStorage.getItem(key) +
		// 		`<br> Current path ${path} <br> Last state ${sessionStorage.getItem('lastState')}`,
		// );
		// clear the key
		sessionStorage.clear(key);

		console.log('in the back button:' + path, props); //state);
		switch (path) {
			case '/breakout':
			case '/alchemer-breakout':
				showTopBar();
				// document.write('going back one more');
				// go back one more
				window.history.back();
				break;
			// case undefined:
			// 	document.location.replace('/restoreState');
			// 	break;
			default:
				break;
		}
		return false;
	} else {
		sessionStorage.setItem(key, referrer);
		const lastPath = sessionStorage.getItem('lastPath') ? sessionStorage.getItem('lastPath') : path;
		sessionStorage.setItem('lastPath', lastPath);
		return true;
	}
}

export function showTopBar(title) {
	if (!title) {
		title = '';
	}
	// call the bridge to enable navigation
	let bridge = null;
	if (window.androidBridge) {
		bridge = window.androidBridge;
	} else if (window.webkit && window.webkit.messageHandlers) {
		bridge = window.webkit.messageHandlers.postEvent;
	}
	console.log(`Calling the bridge to open top nav bar`);
	if (bridge) {
		bridge.postMessage(JSON.stringify({ action: 'openTopBar', model: JSON.stringify({ title }) }));
	}
}

export function closeTopBar() {
	// call the bridge to disable navigation
	let bridge = null;
	if (window.androidBridge) {
		bridge = window.androidBridge;
	} else if (window.webkit && window.webkit.messageHandlers) {
		bridge = window.webkit.messageHandlers.postEvent;
	}
	console.log(`Calling the bridge to close top nav bar`);
	if (bridge) {
		bridge.postMessage(JSON.stringify({ action: 'closeTopBar' }));
	}
}

export function closeWebview() {
	let bridge = null;
	if (window.androidBridge) {
		bridge = window.androidBridge;
	} else if (window.webkit && window.webkit.messageHandlers) {
		bridge = window.webkit.messageHandlers.postEvent;
	}

	const data = {
		action: 'closeWebview',
	};
	console.log('bridge', bridge);
	console.log('closeWebview post', data);

	sessionStorage.clear('oauth');
	if (bridge) {
		bridge.postMessage(JSON.stringify(data));
	}
}

export function setWVTitle(title) {
	let bridge = null;
	if (window.androidBridge) {
		bridge = window.androidBridge;
	} else if (window.webkit && window.webkit.messageHandlers) {
		bridge = window.webkit.messageHandlers.postEvent;
	}
	if (bridge) {
		bridge.postMessage(
			JSON.stringify({
				action: 'setTitle',
				title: title,
			}),
		);
	}
}

export function showBackBtn() {
	let bridge = null;
	if (window.androidBridge) {
		bridge = window.androidBridge;
	} else if (window.webkit && window.webkit.messageHandlers) {
		bridge = window.webkit.messageHandlers.postEvent;
	}

	const data = {
		action: 'addBackBtn',
	};
	console.log('bridge', bridge);
	console.log('addBackBtn', data);

	if (bridge) {
		bridge.postMessage(JSON.stringify(data));
	}
}

export function hideBackBtn() {
	let bridge = null;
	if (window.androidBridge) {
		bridge = window.androidBridge;
	} else if (window.webkit && window.webkit.messageHandlers) {
		bridge = window.webkit.messageHandlers.postEvent;
	}

	const data = {
		action: 'removeBackBtn',
	};
	console.log('bridge', bridge);
	console.log('removeBackBtn', data);

	if (bridge) {
		bridge.postMessage(JSON.stringify(data));
	}
}

export function showLoader() {
	let bridge = null;
	if (window.androidBridge) {
		bridge = window.androidBridge;
	} else if (window.webkit && window.webkit.messageHandlers) {
		bridge = window.webkit.messageHandlers.postEvent;
	}

	const data = {
		action: 'showLoader',
	};
	console.log('bridge', bridge);
	console.log('showLoader', data);

	if (bridge) {
		bridge.postMessage(JSON.stringify(data));
	}
}

export function hideLoader() {
	let bridge = null;
	if (window.androidBridge) {
		bridge = window.androidBridge;
	} else if (window.webkit && window.webkit.messageHandlers) {
		bridge = window.webkit.messageHandlers.postEvent;
	}

	const data = {
		action: 'hideLoader',
	};
	console.log('bridge', bridge);
	console.log('hideLoader', data);

	if (bridge) {
		bridge.postMessage(JSON.stringify(data));
	}
}

export function completeQuestionnaire(itemId) {
	let bridge = null;
	if (window.androidBridge) {
		bridge = window.androidBridge;
	} else if (window.webkit && window.webkit.messageHandlers) {
		bridge = window.webkit.messageHandlers.postEvent;
	}

	const data = {
		action: 'completeQuestionnaire',
		model: '{"itemId": "' + itemId + '"}',
	};

	console.log('bridge', bridge);
	console.log('completeQuestionnaire', data);

	if (bridge) {
		bridge.postMessage(JSON.stringify(data));
	}
}

export function postEvent(data) {
	let bridge = null;
	if (window.androidBridge) {
		bridge = window.androidBridge;
	} else if (window.webkit && window.webkit.messageHandlers) {
		bridge = window.webkit.messageHandlers.postEvent;
	}

	if (bridge) {
		bridge.postMessage(JSON.stringify(data));
	}
}

export const isAndroid = () => {
	var android = false;
	if (/android/i.test(navigator.userAgent)) {
		android = true;
	}
	return android;
};

export const isiPhone = () => {
	var iphone = false;
	if (/iphone/i.test(navigator.userAgent)) {
		iphone = true;
	}
	return iphone;
};
